import { Theme } from "@mui/material";

const snackbarStyles = {
  assignedUserToast: {
    padding: ".5rem 1rem",
    width: 600,
    backgroundColor: "#999999",
    borderRadius: "0.3125rem",
    color: "#fff",
    fontSize: "1rem",
  },
  revertButton: (theme: Theme) => ({
    color: theme.palette.primary.main,
  }),
  alignRight: {
    textAlign: "right",
  },
  message: {
    textAlign: "center",
  },
};

export default snackbarStyles;
